// extracted by mini-css-extract-plugin
export var chip = "_60-9";
export var chipLabel = "_60-a";
export var close = "_60-7";
export var closeIcon = "_60-8";
export var error = "_60-6";
export var infoTooltip = "_60-2";
export var innerContainer = "_60-1";
export var input = "_60-b";
export var medium = "_60-5";
export var outerContainer = "_60-0";
export var small = "_60-4";
export var xSmall = "_60-3";